<template>
    <div class="mdmdt" v-html="html"></div>
  </template>

<script>
import MarkdownIt from 'markdown-it';
import '../../../public/css/mdmdt-light.less';
export default {
  props: ['value'],
  data() {
    return {
      md: null,
    };
  },
  mounted() {
    this.md = new MarkdownIt();
  },
  computed: {
    html() {
      if (this.md && this.value) {
        return this.md.render(this.value); // 这里要用 this.md.render 而不是 MarkdownIt.render
      } else {
        return '';
      }
    },
  },
};
</script>

  <style>
  </style>

